function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.43 1.63l-5.86 12.14-13.11 1.95c-2.35.35-3.3 3.31-1.59 5l9.48 9.45-2.24 13.34c-.4 2.41 2.08 4.22 4.16 3.09L24 40.3l11.73 6.3c2.08 1.12 4.56-.68 4.16-3.1l-2.24-13.33 9.48-9.44c1.7-1.7.76-4.66-1.59-5l-13.1-1.96-5.87-12.14a2.85 2.85 0 00-5.14 0z"
})));